var _rect, _rect2, _rect3, _rect4, _path, _path2, _g, _path3, _path4, _g2, _path5, _path6, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlaanTvLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 55,
    viewBox: "0 0 125 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 125,
    height: 55,
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 3387,
    transform: "translate(-194 -1825)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: -95,
    y: -176,
    width: 1242,
    height: 587,
    rx: 20,
    fill: "url(#paint0_linear_0_1)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: -24,
    y: -28,
    width: 343,
    height: 372,
    rx: 22,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122.744 18.4522C120.944 17.7715 118.931 18.678 118.25 20.4783L113.295 34.38L108.355 20.4783C107.813 19.0458 106.429 18.1812 104.981 18.2296C104.942 18.2296 104.907 18.2296 104.868 18.2296H94.2505V15.6712C94.2505 13.8452 92.8954 12.2418 91.0759 12.0837C89.0079 11.903 87.2754 13.529 87.2754 15.5583V36.7287C87.2754 42.31 91.8018 46.8332 97.3799 46.8332H101.222C103.129 46.8332 104.674 45.2878 104.674 43.3811C104.674 41.4745 103.129 39.9291 101.222 39.9291H97.438C95.6764 39.9291 94.2505 38.5031 94.2505 36.7416V25.2047H102.697L110.033 44.3458C110.714 46.146 112.727 47.0526 114.527 46.3718C115.44 46.0266 116.121 45.3395 116.486 44.5103L124.774 22.9528C125.454 21.1526 124.548 19.1394 122.748 18.4587",
    fill: "#FF7F41"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 36,
    y: 7,
    width: 43,
    height: 48
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.011 38.6194C36.011 49.895 42.1247 54.5085 48.1255 54.5085C54.9166 54.5085 62.253 47.585 62.253 33.651L53.681 34.0027C53.681 37.5644 52.5421 45.0137 48.9804 45.0137C45.751 45.0137 45.1089 40.2002 45.1089 37.8257C45.1089 26.7663 53.2842 15.4746 61.9885 15.4746C70.6928 15.4746 73.7254 25.4306 73.7254 30.7732C73.7254 40.6648 68.3344 49.1626 67.2149 50.6144C66.6858 51.3403 66.9439 52.063 67.3956 52.4663C68.0602 53.0567 68.9313 52.8792 69.5217 52.2211C70.7089 50.9016 78.9325 40.7293 78.9325 28.0052C78.9325 16.5327 72.1414 7.17029 61.2626 7.17029C47.3576 7.17029 36.0078 24.5112 36.0078 38.6226",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.936 7.16699H36.0112V54.5084H78.936V7.16699Z",
    fill: "url(#paint1_radial_0_1)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1239 31.9216C10.6691 28.6019 13.4598 26.1919 16.3859 26.5822C19.3799 26.9081 21.3543 29.8375 20.8091 33.1605C20.2638 36.4157 17.4732 38.8257 14.547 38.4999C11.5531 38.174 9.64638 35.1801 10.1239 31.9216Z",
    fill: "#DF1995"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 17,
    width: 32,
    height: 38
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6968 17.3198C24.8902 17.6811 24.4547 18.5877 24.816 19.3942C25.2903 20.6686 26.3872 24.0852 26.3872 29.0309C26.3872 38.5095 20.2509 44.5426 14.2179 44.5426C8.1849 44.5426 4.74576 40.0097 4.74576 34.209C4.74576 28.4083 8.01713 23.3722 8.37202 22.7914C8.73013 22.1462 8.56882 21.2816 7.92357 20.9235C7.28156 20.5008 6.48146 20.6654 6.05882 21.3074C2.90036 25.795 0 31.3699 0 39.6678C0 47.2364 5.61361 54.5115 13.6533 54.5115C23.5288 54.5115 31.3426 44.1683 31.3426 33.596C31.7395 24.24 27.9551 18.4715 27.6486 17.9328C27.3873 17.4521 26.8808 17.194 26.3452 17.194C26.1291 17.194 25.9065 17.2359 25.6935 17.323",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2998 1.73174L-18.1812 40.0515L19.4392 69.9761L49.9202 31.6563L12.2998 1.73174Z",
    fill: "url(#paint2_linear_0_1)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9559 1.23397C59.2205 1.56304 59.0204 2.09214 58.8236 2.55349C58.4946 3.27939 57.5719 4.53116 56.2524 4.53116C54.8683 4.53116 52.9552 3.80526 52.097 3.80526C51.5679 3.80526 51.042 3.93753 50.5129 4.39888C50.2484 4.66343 49.8548 4.66343 49.5902 4.53116C49.2612 4.26661 49.2611 3.54071 49.4579 3.01484C49.787 2.15667 50.6452 1.16944 51.897 1.16944C52.8874 1.16944 55.391 1.82759 56.1814 1.82759C56.6427 1.82759 57.1718 1.69532 57.6977 1.23397C58.159 0.837144 58.6881 0.969419 58.9495 1.23397",
    fill: "#F57046"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 3,
    width: 55,
    height: 52
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.31716 18.1812C7.92034 18.7103 7.98809 19.433 8.44944 19.8943C9.04306 20.4879 9.83348 20.4879 10.4271 19.9588C14.4502 16.0035 20.6155 9.8253 32.0879 9.8253C46.5929 9.8253 53.6809 22.8624 53.6809 34.0058C53.6809 37.5675 52.5421 45.0168 48.9803 45.0168L48.1221 54.5115C54.9133 54.5115 62.2497 47.5881 62.2497 33.6541C62.2497 17.8295 51.6065 3.63098 34.5656 3.63098C23.7514 3.63098 12.7984 11.6578 8.31394 18.1844",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.3331 -22.6847L-16.7192 35.3964L41.8437 80.8224L86.896 22.7413L28.3331 -22.6847Z",
    fill: "url(#paint3_linear_0_1)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: -60.3165,
    y1: 411,
    x2: 712.626,
    y2: -557.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#F87F39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#F05A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#EB426F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF1995"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_0_1",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.6986 48.8424) scale(26.5711 46.7446)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9B21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FF9B21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCC00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_1",
    x1: 3.37485,
    y1: 27.4227,
    x2: 24.2125,
    y2: 43.9977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA426F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E5307F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E01F8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF1995"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_0_1",
    x1: 49.5175,
    y1: 40.1628,
    x2: 19.6026,
    y2: 16.9584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9B21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FF9B21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#FC9129"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#F6783E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#ED5062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA426F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 3387,
    fill: "white",
    transform: "translate(-194 -1825)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlaanTvLogo);
export default __webpack_public_path__ + "static/media/alaan-tv-logo.1eda94938ab0929ad42f8daa74efc307.svg";
export { ForwardRef as ReactComponent };